import * as React from 'react';
import { NavLink, Link, withRouter, RouteComponentProps } from 'react-router-dom';
import Routes from 'src/core/Routes';
import { connect } from 'react-redux';
import { ReduxStoreModel } from '../../redux/ReduxModel';
import { withLocalize, LocalizeContextProps, Translate } from 'react-localize-redux';
import { Layout, Menu, Icon } from 'antd';
import '../SideNav.less';
import { Grades } from 'src/constants/Grades';

const { Sider } = Layout;

interface UserSideNavProps extends RouteComponentProps<{}> {
    gradeId: number;
}

interface UserSideNavState {
    selectedKey: string;
}

class UserSideNav extends React.Component<UserSideNavProps, UserSideNavState> {
    constructor(props: UserSideNavProps) {
        super(props);

        this.state = {
            selectedKey: 'menu'
        };
    }

    componentWillMount() {
        this.selectMenuItem(this.props.location.pathname);
    }

    private selectMenuItem(key: string) {
        this.setState({
            selectedKey: key
        });
    }

    private isParentUser(gradeId: number) {
        return this.props.gradeId === Grades.Default.id || this.props.gradeId == null;
    }

    /**
     * Visible for grades 3+ and parents
     */
    private renderHollandGuideLink() {
        if (this.props.gradeId >= Grades.Third.id || this.isParentUser(this.props.gradeId)) {
            return <Menu.Item key={Routes.getRoute(Routes.HOLLAND_AREAS_GUIDE)}>
                <NavLink to={Routes.getRoute(Routes.HOLLAND_AREAS_GUIDE)}>
                    <Icon type="book" /><Translate id={"common.hollandAreas"} />
                </NavLink>
            </Menu.Item>;
        }
    }

    private renderOccupationDbLink() {
        if (this.props.gradeId >= Grades.Third.id || this.isParentUser(this.props.gradeId)) {
            return <Menu.Item key={Routes.getRoute(Routes.OCCUPATIONDB)}>
                <NavLink to={Routes.getRoute(Routes.OCCUPATIONDB)}>
                    <Icon type="book" /><Translate id={"public.occupationdb.title"} />
                </NavLink>
            </Menu.Item>;
        }
    }

    /**
     * Visible for grades 4+ and parents
     */
    private renderTrainingAndEducationGuideLink() {
        if (this.props.gradeId === Grades.Fourth.id || this.props.gradeId === Grades.Fifth.id || this.isParentUser(this.props.gradeId)) {
            return <Menu.Item key={Routes.getRoute(Routes.TRAINING_AND_EDUCATION_GUIDE)}>
                <NavLink to={Routes.getRoute(Routes.TRAINING_AND_EDUCATION_GUIDE)}>
                    <Icon type="book" /><Translate id={"common.trainingAndEducation"} />
                </NavLink>
            </Menu.Item>;
        }
    }

    public render() {
        return <Sider
            width="300px"
            breakpoint="md"
            collapsedWidth="0"
            className="side-nav">
            <Menu className="parentSideNav" mode="inline" >
                <Menu.Item key={Routes.getRoute(Routes.LOGIN)}>
                    <NavLink to={Routes.getRoute(Routes.LOGIN)}>
                        <Icon type="home" /><Translate id={"common.home"} />
                    </NavLink>
                </Menu.Item>

                <Menu.Item key={Routes.getRoute(Routes.PARENTS_HOME)}>
                    <NavLink to={Routes.getRoute(Routes.PARENTS_HOME)}>
                        <Icon type="home" /><Translate id={"public.parents.home"} />
                    </NavLink>
                </Menu.Item>

                <Menu.Item key={Routes.getRoute(Routes.PARENTS, "PK")}>
                    <NavLink to={Routes.getRoute(Routes.PARENTS, "PK")}>
                        <Icon type="star" /><Translate id={"public.parents.PK"} />
                    </NavLink>
                </Menu.Item>
                <Menu.Item key={Routes.getRoute(Routes.PARENTS, "K")}>
                    <NavLink to={Routes.getRoute(Routes.PARENTS, "K")}>
                        <Icon type="star" /><Translate id={"public.parents.K"} />
                    </NavLink>
                </Menu.Item>
                <Menu.Item key={Routes.getRoute(Routes.PARENTS, 1)}>
                    <NavLink to={Routes.getRoute(Routes.PARENTS, 1)}>
                        <Icon type="star" /><Translate id={"public.parents.1st"} />
                    </NavLink>
                </Menu.Item>

                <Menu.Item key={Routes.getRoute(Routes.PARENTS, 2)}>
                    <NavLink to={Routes.getRoute(Routes.PARENTS, 2)}>
                        <Icon type="star" /><Translate id={"public.parents.2nd"} />
                    </NavLink>
                </Menu.Item>
                <Menu.Item key={Routes.getRoute(Routes.PARENTS, 3)}>
                    <NavLink to={Routes.getRoute(Routes.PARENTS, 3)}>
                        <Icon type="star" /><Translate id={"public.parents.3rd"} />
                    </NavLink>
                </Menu.Item>
                <Menu.Item key={Routes.getRoute(Routes.PARENTS, 4)}>
                    <NavLink to={Routes.getRoute(Routes.PARENTS, 4)}>
                        <Icon type="star" /><Translate id={"public.parents.4th"} />
                    </NavLink>
                </Menu.Item>
                <Menu.Item key={Routes.getRoute(Routes.PARENTS, 5)}>
                    <NavLink to={Routes.getRoute(Routes.PARENTS, 5)}>
                        <Icon type="star" /><Translate id={"public.parents.5th"} />
                    </NavLink>
                </Menu.Item>
                {this.renderTrainingAndEducationGuideLink()}
                {this.renderHollandGuideLink()}
                {this.renderOccupationDbLink()}
            </Menu>
        </Sider>;
    }
}

function mapStateToProps(state: ReduxStoreModel) {
    return {
        gradeId: state.User.gradeId
    };
}

export default connect(mapStateToProps)(withRouter(UserSideNav));



// WEBPACK FOOTER //
// ./src/layouts/user/UserSideNav.tsx